import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: "[validDateRange]",
  providers: [{ provide: NG_VALIDATORS, useExisting: DateRangeValidatorDirective, multi: true }]
})
export class DateRangeValidatorDirective implements Validator {

  @Input('minDate') minDate: Date;
  @Input('maxDate') maxDate: Date;

  constructor() { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    if (!control) {
      return null;
    }
    if (control.errors && !control.errors.dateInvalid) {
      return null;
    }
    const utcDate = new Date(control.value);
    const dateToCheck = new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate(), utcDate.getUTCHours(), utcDate.getUTCMinutes(), utcDate.getUTCSeconds(), utcDate.getUTCMilliseconds());
    console.log(`control.value: ${control.value}`);
    console.log(`utcDate: ${utcDate.toUTCString()}`);
    console.log(`dateToCheck: ${dateToCheck}`);
    console.log(`minDate: ${this.minDate}`);
    console.log(`maxDate: ${this.maxDate}`);
    if (dateToCheck < this.minDate || dateToCheck > this.maxDate) {
      return { 'dateInvalid': true };
    } else {
      return null;
    }
  }
}
